<template>
<div class="item-wrap ticket-tab-wrap pos-r">
    <scroller ref="infinite" class="scroller" :on-refresh="_onRefresh" :on-infinite="_onEndReached" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''">
        <div class="list-wrap user-list-wrap">
            <div class="user-list-item-wrap" v-for="(item, index) in dataSources" :key="index">
                <student-record-item :item="item" @onRefresh="_onRefresh" />
            </div>
            <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
        </div>
    </scroller>
</div>
</template>

<script>
import studentRecordItem from "../item/studentRecordItem";
export default {
    name: "MyTicketTab",
    props: ["item", "type", "user_id"],
    components: {
        studentRecordItem,
    },
    computed: {},
    data() {
        return {
            loading: true,
            isShowSendAction: false,
            dataSources: [],
            page: 1,
            limit: 10,
            formData: {
                num: 0,
                desc: "",
            },
            giftCopy: {
                desc: "领取后，可立即解锁众修课程，快来领取吧",
                remark: "注:1用户领取成功后才扣名额，分享出去不会马上扣名额，24小时内可领取。\r\n2、没有推荐人，或者推荐人是您，且满足上面可领条件的用户，才可以领取。",
            },
        };
    },
    mounted() {
        this._requestDataSources();
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                };
            }
            this.$router.push({
                path,
                query,
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            console.log("url---->", url);
            window.location.href = url;
        },

        async _requestDataSources() {
            let url = this.API.agent_student_record;
            let data = {
                type: this.type,
                page: this.page,
                limit: this.limit,
                user_id: this.user_id,
            };
            try {
                const result = await this.$post(url, data);
                let dataSourcesTemp = this.dataSources.slice();
                let dataList = [];
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    dataList = result.data.data || [];
                    if (parseInt(data.page) === 1) {
                        dataSourcesTemp = dataList;
                    } else {
                        if (dataList.length !== 0) {
                            dataSourcesTemp = dataSourcesTemp.concat(dataList);
                        }
                    }
                }
                this.dataSources = dataSourcesTemp;
                this._onStopLoading(dataList.length < this.limit);
            } catch (error) {
                this._onStopLoading(true);
            }
        },

        // 下拉刷新
        _onRefresh() {
            this.page = 1;
            this._requestDataSources();
        },

        // 上拉加载
        _onEndReached() {
            if (this.loading) return;
            this.page++;
            this._requestDataSources();
        },

        // 结束加载
        _onStopLoading(status = true) {
            console.log("status---->", status);
            setTimeout(() => {
                this.loading = false;
                this.$refs && this.$refs.infinite.finishPullToRefresh();
                this.$refs && this.$refs.infinite.finishInfinite(status);
            }, 500);
        },

        async _onSubmitSend() {
            let url = this.API.ticket_grant_ticket;
            let data = this.formData;
            if (data.num < 1) return this.ToastManager("请设置发放数量");
            data.desc = data.desc || this.giftCopy.desc;
            const result = await this.$post(url, data);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this._onPressToNavigate("", "myTicketGift", {
                    ...result.data,
                });
            } else {
                this.ToastManager(result.msg);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.ticket-tab-wrap {
    height: calc(100vh - 5rem - 4.4rem);

    .btn-wrap {
        width: 100%;
        bottom: 0;
        overflow: hidden;

        .btn-item {
            color: #fff;
            height: 4rem;
            border-radius: 5px;
            margin: 1rem 15px 2rem;
            box-shadow: 0 0 1px 0px #6c6c6c61;
            background: linear-gradient(45deg, #7180eb, #acb5f0);
        }
    }

    .send-content-wrap {
        padding: 2rem 2rem;
        border-top: 1px solid #ddd;
        min-height: 22rem;

        .content-item-wrap {
            min-height: 4rem;

            .item-title {
                font-size: 1.4rem;
                width: 8rem;
            }

            .item-con-wrap {
                flex: 1;

                &.text-area-wrap {
                    min-height: 5rem;
                    border-radius: 5px;
                    padding: 0.5rem 1rem;
                    border: 1px solid #ddd;
                }

                .text-area-item {
                    border: 0;
                    width: 100%;
                    height: 100%;
                    font-size: 1.3rem;
                }
            }
        }

        .remark-wrap {
            color: #999;
            margin-top: 2rem;
            line-height: 1.5;
            font-size: 1.2rem;
            white-space: pre-wrap;
        }

        .submit-btn-item {
            height: 4rem;
            color: #fff;
            margin: 3rem auto;
            border-radius: 5px;
            background: linear-gradient(45deg, #7180eb, #acb5f0);
        }
    }
}
</style>
